import { useState } from "react";
import { useTheme } from "../hooks/useTheme";
import { useFontFamily } from "../hooks/useFontFamily";
import { useResumeData } from "../hooks/useResumeData";
import { getData } from "../redux/reducer";
import { FaPhone } from "react-icons/fa";

const Intro = () => {
  const [theme] = useTheme();
  const [resumeData, setResumeData] = useResumeData();
  const [font] = useFontFamily();
  const [flagr, setFlagr] = useState("r-user-name");

  const handleImageClick = () => {
    const input = document.createElement("input");
    input.type = "file";
    input.accept = "image/*";
    input.onchange = (e: any) => {
      e.preventDefault();
      let reader = new FileReader();
      reader.readAsDataURL(e.target.files![0]);
      reader.onloadend = () => {
        setResumeData({ ...resumeData, dp: reader.result as string });
      };
    };
    input.click();
  };

  return (
    <div className={`flex justify-between flex-wrap w-full ${font}`}>
      <div className={"w-full lg:w-5/12"}>
        <div className={"flex w-full"}>
          <img
            src={resumeData.dp}
            alt="Selected"
            className={`w-24 h-24 mr-3 rounded-full cursor-pointer`}
            onClick={handleImageClick}
          />
          <div>
            {flagr === "r-user-name" ? (
              <input
                className={`${theme.fg()} text-2xl font-bold h-8 outline-none bg-transparent w-full`}
                value={`${resumeData.name}`}
                autoFocus
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                  setResumeData({ ...resumeData, name: event.target.value });
                }}
                onBlur={(event) => {
                  if (event.target.value === "") {
                    setResumeData({
                      ...resumeData,
                      name: getData.name,
                    });
                  }
                  setFlagr("");
                }}
                aria-labelledby=""
              />
            ) : (
              <div
                id="r-name"
                className={`w-full ${theme.fg()} text-2xl font-bold cursor-pointer`}
                onClick={(event) => {
                  event.stopPropagation();
                  setFlagr("r-user-name");
                }}
              >
                {`${resumeData.name}`}
              </div>
            )}
            {flagr === "r-user-position" ? (
              <input
                className={` ${theme.fg()} text-md h-6 outline-none bg-transparent w-full`}
                value={`${resumeData.position}`}
                autoFocus
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                  setResumeData({
                    ...resumeData,
                    position: event.target.value,
                  });
                }}
                onBlur={(event) => {
                  if (event.target.value === "") {
                    setResumeData({
                      ...resumeData,
                      position: getData.position,
                    });
                  }
                  setFlagr("");
                }}
              />
            ) : (
              <div
                id="r-user-name"
                className={`w-full ${theme.fg()} text-md h-6 truncate cursor-pointer`}
                onClick={(event) => {
                  event.stopPropagation();
                  setFlagr("r-user-position");
                }}
              >
                {`${resumeData.position}`}
              </div>
            )}
          </div>
        </div>
        {flagr === "r-user-description" ? (
          <textarea
            autoFocus
            spellCheck={false}
            rows={4}
            className={`resize-none min-w-[100%] ${theme.fg()} text-sm mt-4 outline-none bg-transparent h-[4.55rem]`}
            value={`${resumeData.description}`}
            onChange={(event: React.ChangeEvent<HTMLTextAreaElement>) => {
              setResumeData({
                ...resumeData,
                description: event.target.value,
              });
            }}
            onFocus={(event) => {
              event.target.selectionStart = event.target.value.length;
              event.target.scrollTop = event.target.scrollHeight;
            }}
            onBlur={(event) => {
              if (event.target.value === "") {
                setResumeData({
                  ...resumeData,
                  description: getData.description,
                });
              }
              setFlagr("");
            }}
          />
        ) : (
          <div
            id="r-user-description"
            className={`${theme.fg()} text-sm mt-4 line-clamp-4 text-ellipsis cursor-pointer`}
            onClick={(event) => {
              event.stopPropagation();
              setFlagr("r-user-description");
            }}
            title={`${resumeData.description}`}
          >
            {`${resumeData.description}`}
          </div>
        )}
      </div>
      <div
        className={
          "w-full lg:w-6/12 lg:pl-2 mt-6 lg:mt-0 flex flex-col items-end"
        }
      >
        <div className="flex justify-center items-center w-full flex-row-reverse lg:flex-row">
          {flagr === "r-user-email" ? (
            <input
              className={`${theme.fg()} text-sm outline-none bg-transparent w-full text-left ml-2 lg:ml-0 lg:text-right font-medium`}
              value={`${resumeData.email}`}
              autoFocus
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                setResumeData({ ...resumeData, email: event.target.value });
              }}
              onBlur={(event) => {
                if (event.target.value === "") {
                  setResumeData({
                    ...resumeData,
                    email: getData.email,
                  });
                }
                setFlagr("");
              }}
            />
          ) : (
            <div
              id="r-user-email"
              className={`${theme.fg()} text-sm truncate w-full text-left lg:text-right font-medium ml-2 lg:ml-0 cursor-pointer`}
              onClick={(event) => {
                event.stopPropagation();
                setFlagr("r-user-email");
              }}
            >
              {`${resumeData.email}`}
            </div>
          )}
          <i className={`fa fa-envelope text-sm lg:ml-2 ${theme.fg()}`} />
        </div>
        <div className="flex justify-center items-center w-full flex-row-reverse lg:flex-row mt-4">
          {flagr === "r-user-ph_no" ? (
            <input
              className={` ${theme.fg()} text-sm outline-none bg-transparent w-full text-left ml-2 lg:ml-0 lg:text-right font-medium`}
              value={`${resumeData.ph_no}`}
              autoFocus
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                setResumeData({ ...resumeData, ph_no: event.target.value });
              }}
              onBlur={(event) => {
                if (event.target.value === "") {
                  setResumeData({
                    ...resumeData,
                    ph_no: getData.ph_no,
                  });
                }
                setFlagr("");
              }}
            />
          ) : (
            <div
              id="r-user-ph_no"
              className={`${theme.fg()} text-sm truncate w-full text-left lg:text-right font-medium ml-2 lg:ml-0 cursor-pointer`}
              onClick={(event) => {
                event.stopPropagation();
                setFlagr("r-user-ph_no");
              }}
            >
              {`${resumeData.ph_no}`}
            </div>
          )}
          <FaPhone className={`text-md lg:ml-2 ${theme.fg()}`} />
        </div>
        <div className="flex justify-center items-center w-full flex-row-reverse lg:flex-row mt-4">
          {flagr === "r-user-location" ? (
            <input
              className={` ${theme.fg()} text-sm outline-none bg-transparent w-full text-left ml-2 lg:ml-0 lg:text-right font-medium`}
              value={`${resumeData.location}`}
              autoFocus
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                setResumeData({
                  ...resumeData,
                  location: event.target.value,
                });
              }}
              onBlur={(event) => {
                if (event.target.value === "") {
                  setResumeData({
                    ...resumeData,
                    location: getData.location,
                  });
                }
                setFlagr("");
              }}
            />
          ) : (
            <div
              id="r-user-location"
              className={`${theme.fg()} text-sm truncate w-full text-left lg:text-right font-medium ml-2 lg:ml-0 cursor-pointer`}
              onClick={(event) => {
                event.stopPropagation();
                setFlagr("r-user-location");
              }}
            >
              {`${resumeData.location}`}
            </div>
          )}
          <i
            className={`fa-solid fa-location-dot text-md lg:ml-2 ${theme.fg()}`}
          />
        </div>
        <div className="flex justify-center items-center w-full flex-row-reverse lg:flex-row mt-4">
          {flagr === "r-user-linkedin" ? (
            <input
              className={`${theme.fg()} text-sm outline-none bg-transparent w-full text-left ml-2 lg:ml-0 lg:text-right font-medium`}
              value={`${resumeData.linkedin}`}
              autoFocus
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                setResumeData({
                  ...resumeData,
                  linkedin: event.target.value,
                });
              }}
              onBlur={(event) => {
                if (event.target.value === "") {
                  setResumeData({
                    ...resumeData,
                    linkedin: getData.linkedin,
                  });
                }
                setFlagr("");
              }}
            />
          ) : (
            <div
              id="r-user-linkedin"
              className={`${theme.fg()} text-sm truncate w-full text-left lg:text-right font-medium ml-2 lg:ml-0 cursor-pointer`}
              onClick={(event) => {
                event.stopPropagation();
                setFlagr("r-user-linkedin");
              }}
              title={`${resumeData.linkedin}`}
            >
              {`${resumeData.linkedin}`}
            </div>
          )}
          <i
            className={`fa-brands fa-linkedin text-md lg:ml-2 ${theme.fg()}`}
          />
        </div>
      </div>
    </div>
  );
};

export default Intro;
